import { render, staticRenderFns } from "./gp-skin-response.vue?vue&type=template&id=2cfe0b63&scoped=true&"
import script from "./gp-skin-response.vue?vue&type=script&lang=js&"
export * from "./gp-skin-response.vue?vue&type=script&lang=js&"
import style0 from "./gp-skin-response.vue?vue&type=style&index=0&id=2cfe0b63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe0b63",
  null
  
)

component.options.__file = "gp-skin-response.vue"
export default component.exports